<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="activeTab === module ? 'active' : ''" @click="changeTab(module)" v-for="(title,module) in modules" v-if="hasModule(module)">
					<a><i :class="getIcon(module)"></i> {{title}}</a>
				</li>
			</ul>
		</nav>

		<div class="main" v-for="(title,module) in modules" v-if="activeTab === module">
			<component :data="data" :is="getComponentName(module)"/>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object
			},
		},
		data() {
			return {
				id: this.data.id,
				slug: this.data.slug,
				name: this.data.name,
				hasSpecificModule: false,
				modules: this.data.settings.modules,
				roles: this.$currentUserRoles,

				activeTab: 'content',
			}
		},
		created() {

			if (typeof this.modules.toolSpecific !== 'undefined') {
				this.modules.toolSpecific = 'Misc. ' + this.name;
			}

			if (typeof Vue.options.components['toolshub-' + this.slug] !== 'undefined') {
				this.hasSpecificModule = true;
			}
		},
		mounted() {
			this.checkUrl();
		},
		methods: {
			changeTab: function (name) {
				this.activeTab = name;
				this.$forceUpdate();
				this.updateUrl();
			},
			checkUrl: function () {
				var tabQuery = this.getParameterByName('tab');

				if (tabQuery !== null) {
					let vm = this;
					Object.keys(this.modules).forEach(key => {
						if (key.toLowerCase() === tabQuery.toLowerCase()) {
							if (vm.checkPermission(key)) {
								vm.activeTab = key;
							}
						}
					});
				} else {
					this.updateUrl();
				}
			},
			getParameterByName: function (name) {
				var url = window.location.href;
				name = name.replace(/[\[\]]/g, '\\$&');
				var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
					results = regex.exec(url);
				if (!results) return null;
				if (!results[2]) return '';
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			},
			updateUrl: function () {
				var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?tab=' + this.activeTab.toLowerCase();
				window.history.pushState({path: newurl}, '', newurl);
			},
			hasModule: function (module) {
				if (module === 'recommendedArticles' && this.data.settings.recommendedArticles.hasRecommendedArticles !== true) {
					return false;
				}
				if (module === 'toolSpecific' && this.hasSpecificModule === false) {
					return false;
				}
				if (module === 'settings') {
					return this.checkPermission('settings');
				}
				if (module === 'seo') {
					return this.checkPermission('seo');
				}
				return true;
			},
			getComponentName: function (module) {
				if (module === 'toolSpecific') {
					return 'toolshub-' + this.slug;
				}
				if (module === 'seo') {
					return 'module-metaseo';
				}
				return 'staticpage-module-' + module;
			},
			getIcon: function (module) {
				if (module === 'content') {
					return 'fas fa-pen';
				}
				if (module === 'settings') {
					return 'fas fa-cog';
				}
				return 'fas fa-bookmark';
			},
			checkPermission(element) {
				if (element === 'settings') {
					if (this.roles.includes('staticpage.create')) {
						return true;
					}
				}
				if (element === 'recommendedArticles') {
					return true;
				}
				if (element === 'toolSpecific') {
					return true;
				}
				if (element === 'seo') {
					return true;
				}
				return false;
			}
		}
	}
</script>

